import UtilSequence from "@/utils/UtilSequence.mjs";
import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import JobItensService from "./JobItensService";
import JobSubitensService from "./JobSubitensService";
import RevisaoDeJobService from "./RevisaoDeJobService";
import RevisaoDeJobItensService from "./RevisaoDeJobItensService";
import RevisaoDeJobSubItensService from "./RevisaoDeJobSubItensService";
import SolicitacaoDeOrcamentoService from "./SolicitacaoDeOrcamentoService";
import UtilArray from "@/utils/UtilArray.mjs";
import UtilDateTime from "@/utils/UtilDateTime";

export default {

    async getJob(jobID = ""){

        let job;

        try{

            job = await ERP.getOneById(Schema.JOB, jobID);
            if(job.status != 200){
                throw job;
            }

            console.log(job);

        }catch(e){

            console.log(e);
            return job;

        }

        return job;

    },

    async alterarJob(jobValores = {}){

        let job;

        try{

            job = await ERP.patchOne(Schema.JOB, jobValores);
            if(job.status != 200){
                throw job;
            }

            console.log(job);

        }catch(e){

            console.log(e);
            return job;

        }

        return job;

    },

    async alterarDatasEntregaFinal(jobValores = {}){

        let job;

        try{

            const jobAtual = await ERP.getOneById(Schema.JOB, jobValores?.id || "");
            if(jobAtual.status != 200){
                throw jobAtual;
            }

            const payload = {
                ...jobAtual.data,
                id: jobValores?.id || "",
                dateFinalContratual: jobValores?.dateFinalContratual || null,
                dateFinalEfetiva: jobValores?.dateFinalEfetiva || null,
            };

            delete payload.dataFinalContratual;
            delete payload.dataFinalEfetiva;
            delete payload.dataFinalContratualFormatada;
            delete payload.dataFinalEfetivaFormatada;

            job = await ERP.putOne(Schema.JOB, payload);
            if(job.status != 200){
                throw job;
            }

            console.log(job);

        }catch(e){

            console.log(e);
            return job;

        }

        return job;

    },

    async salvarPreenchimentoDeComercial(jobValores = {}){

        let job;

        try{

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //====================== Gerencia Itens do Job =====================//
            //==================================================================//
            const gerenciaItens = async (job) =>{

                let itens = await UtilSequence.each({
                    list: job?.itens,
                    callback: async (item)=>{

                        //==================================================================//
                        //===================== Remove Itens do Job ========================//
                        //==================================================================//

                        if(item.remover == true){
                            item = await removeItem(item);
                            return;
                        }

                        //==================================================================//
                        //======================= Cria Itens do Job ========================//
                        //==================================================================//

                        if(item.rascunho == true){
                            item = await criaItem(item);
                            return item;
                        }

                        //==================================================================//
                        //====================== Altera Itens do Job =======================//
                        //==================================================================//

                        item = await alteraItem(item);
                        return item;

                    },
                });

                return itens;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //===================== Remove Item do Job =========================//
            //==================================================================//

            const removeItem = async (item) => {

                await gerenciaSubItens(item);
                
                let itemValores = {
                    id: item?.id
                }

                item = await JobItensService.removeItem(itemValores);
                if(item.status != 200){
                    throw item;
                }

                return item;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //======================= Cria Item do Job =========================//
            //==================================================================//

            const criaItem = async (item) => {

                let subItens = await gerenciaSubItens(item);
                let subItensIDs = subItens?.map(({id})=>id);
                
                let itemValores = {
                    sequencia: item?.sequencia,
                    tipoDeEquipamento: item?.tipoDeEquipamento,
                    descricao: item?.descricao,
                    dataPrazoEntrega: UtilDateTime.toFormatUTC({dateTime:item?.dataPrazoEntrega}),
                    quantidade: item?.quantidade,
                    precoUnitario: item?.precoUnitario,
                    precoTotal: item?.precoTotal,
                    valorBaseICMS_ISS: item?.valorBaseICMS_ISS,
                    porcentagemICMS: item?.porcentagemICMS,
                    valorICMS: item?.valorICMS,
                    porcentagemIPI: item?.porcentagemIPI,
                    valorIPI: item?.valorIPI,
                    porcentagemISS: item?.porcentagemISS,
                    valorISS: item?.valorISS,
                    itens: subItensIDs,
                }

                item = await JobItensService.criaItem(itemValores);
                if(item.status != 200){
                    throw item;
                }

                return item.data;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //====================== Altera Item do Job ========================//
            //==================================================================//

            const alteraItem = async (item) => {

                let subItens = await gerenciaSubItens(item);
                let subItensIDs = subItens?.map(({id})=>id);
                
                let itemValores = {
                    id: item?.id,
                    sequencia: item?.sequencia,
                    tipoDeEquipamento: item?.tipoDeEquipamento,
                    descricao: item?.descricao,
                    dataPrazoEntrega: UtilDateTime.toFormatUTC({dateTime:item?.dataPrazoEntrega}),
                    quantidade: item?.quantidade,
                    precoUnitario: item?.precoUnitario,
                    precoTotal: item?.precoTotal,
                    valorBaseICMS_ISS: item?.valorBaseICMS_ISS,
                    porcentagemICMS: item?.porcentagemICMS,
                    valorICMS: item?.valorICMS,
                    porcentagemIPI: item?.porcentagemIPI,
                    valorIPI: item?.valorIPI,
                    porcentagemISS: item?.porcentagemISS,
                    valorISS: item?.valorISS,
                    itens: subItensIDs,
                }

                item = await JobItensService.alteraItem(itemValores);
                if(item.status != 200){
                    throw item;
                }

                return item.data;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //==================== Gerencia Subitens do Item ===================//
            //==================================================================//

            const gerenciaSubItens = async (item) => {

                let subItens = await UtilSequence.each({
                    list: item?.itens,
                    callback: async (subItem)=>{

                        //==================================================================//
                        //=================== Remove Subitens do Item ======================//
                        //==================================================================//

                        if(item.remover == true || subItem.remover == true){
                            subItem = await removeSubitem(subItem);
                            return;
                        }

                        //==================================================================//
                        //====================== Cria Subitens do Item =====================//
                        //==================================================================//

                        if(subItem.rascunho == true){
                            subItem = await criaSubitem(subItem);
                            return subItem;
                        }

                        //==================================================================//
                        //=================== Altera Subitens do Item ======================//
                        //==================================================================//

                        subItem = await alteraSubitem(subItem);
                        return subItem;

                    },
                });

                return subItens;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //=================== Remove Subitem do Item =======================//
            //==================================================================//

            const removeSubitem = async (subItem) => {

                let subItemValores = {
                    id: subItem?.id
                }

                subItem = await JobSubitensService.removeSubItem(subItemValores);
                if(subItem.status != 200){
                    throw subItem;
                }

                return subItem;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //======================= Cria Item do Job =========================//
            //==================================================================//

            const criaSubitem = async (subItem) => {
                
                let subItemValores = {
                    descricao: subItem?.descricao,
                    quantidade: subItem?.quantidade,
                    sequencia: subItem?.sequencia,
                    valorTotal: subItem?.valorTotal,
                    valorUnitario: subItem?.valorUnitario,
                }

                subItem = await JobSubitensService.criaSubitem(subItemValores);
                if(subItem.status != 200){
                    throw subItem;
                }

                return subItem.data;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //===================== Altera Subitem do Job ======================//
            //==================================================================//

            const alteraSubitem = async (subItem) => {

                let subItemValores = {
                    id: subItem?.id,
                    descricao: subItem?.descricao,
                    quantidade: subItem?.quantidade,
                    sequencia: subItem?.sequencia,
                    valorTotal: subItem?.valorTotal,
                    valorUnitario: subItem?.valorUnitario,
                }

                subItem = await JobSubitensService.alteraSubitem(subItemValores);
                if(subItem.status != 200){
                    throw subItem;
                }

                return subItem.data;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //======================= Altera Job Itens =========================//
            //==================================================================//

            jobValores.itens = await gerenciaItens(jobValores);
            console.log(jobValores);
            jobValores.itens = jobValores?.itens?.map(({id}) => id) || [];

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //========================= Altera o Job ===========================//
            //==================================================================//

            jobValores = {
                id: jobValores.id,
                dataEntregaContratual: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEntregaContratual}),
                ncm: jobValores?.ncm,
                email: jobValores?.clienteEmailXML,
                pedidoCompra: jobValores?.clientePedidoDeCompra,
                description: jobValores?.descricao,
                condicaoDePagamento: jobValores?.condicaoDePagamento,
                observacao: jobValores?.observacao,
                transporte: jobValores.transporte,
                //
                naoTemEnvioAprov: jobValores?.naoTemEnvioAprovacao,
                dateEnvAprov: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEnvioAprovacaoContratual}),
                dateEnvEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEnvioAprovacaoEfetiva}),
                //
                naoTemAprov: jobValores?.naoTemAprovacao,
                dateAprovPrevista: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataAprovacaoPrevista}),
                dateAprovEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataAprovacaoEfetiva}),
                //
                naoTemInspec: jobValores?.naoTemInspecao,
                dateInspecPrev: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataInspecaoPrevista}),
                dateInspecEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataInspecaoEfetiva}),
                //
                naoTemEntregaFis: jobValores?.naoTemEntregaFiscal,
                dateEntregaFisPrev: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEntregaFiscalPrevista}),
                dateEntregaFisEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEntregaFiscalEfetiva}),
                //
                naoTemMontagem: jobValores?.naoTemMontagem,
                dateContratualMontagem: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataMontagemContratual}),
                dateEfetivaMontagem: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataMontagemEfetiva}),
                //
                naoTemStartup: jobValores?.naoTemStartup,
                dateStatupPrev: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataStartupPrevista}),
                dateStatupEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataStartupEfetiva}),
                //
                dateFinalContratual: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataFinalContratual}),
                dateFinalEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataFinalEfetiva}),
                //
                jobItens: jobValores?.itens,
            }

            job = await this.alterarJob(jobValores);
            if(job.status != 200){
                throw job;
            }

            console.log(job);

        }catch(e){

            console.log(e);
            return job;

        }

        return job;

    },

    async finalizarPreenchimentoDeComercial(jobValores = {}){

        let job;

        try{

            //==================================================================//
            //========================= Altera o Job ===========================//
            //==================================================================//

            jobValores = {
                id: jobValores.id,
                status: "Aguardando Gestor"
            }

            job = await this.alterarJob(jobValores);
            if(job.status != 200){
                throw job;
            }

        }catch(e){

            console.log(e);
            return job;

        }

        return job;

    },


    async finalizarPreenchimentoDeGestor(jobValores = {}){

        let job;

        try{

            //==================================================================//
            //========================== Pega o Job ============================//
            //==================================================================//

            let jobID = jobValores?.id;

            job = await this.getJob(jobID);
            if(job.status != 200){
                throw job;
            }

            //==================================================================//
            //========== Pega o Colaborador do Gestor de Contratos =============//
            //==================================================================//

            let gestorDeContratosID = jobValores?.gestorDeContratos;
            
            let gestorDeContratos = await ERP.getOneById(Schema.COLABORADOR, gestorDeContratosID);
            if(gestorDeContratos.status != 200){
                throw gestorDeContratos;
            }

            let gestorDeContratosUser = gestorDeContratos.data.user;

            //==================================================================//
            //======== Pega o Colaborador do Coordenador de Contratos ==========//
            //==================================================================//

            let coordenadorDeContratosID = jobValores?.coordenadorDeContratos;
            
            let coordenadorDeContratos = await ERP.getOneById(Schema.COLABORADOR, coordenadorDeContratosID);
            if(coordenadorDeContratos.status != 200){
                throw coordenadorDeContratos;
            }

            let coordenadorDeContratosUser = coordenadorDeContratos.data.user;

            //==================================================================//
            //========================= Altera o Job ===========================//
            //==================================================================//

            let jobOwners = UtilArray.unique([...job.data.owners, gestorDeContratosUser,coordenadorDeContratosUser]);

            jobValores = {
                id: jobValores.id,
                gestorDeContratos: gestorDeContratosID,
                collaboradorId: coordenadorDeContratosID,
                status: "Aguardando Coordenador",
                owners: jobOwners || [],
            }

            job = await this.alterarJob(jobValores);
            if(job.status != 200){
                throw job;
            }

        }catch(e){

            console.log(e);
            return job;

        }

        return job;

    },

    async salvarPreenchimentoDeCoordenador(jobValores = {}){

        let job;

        try{

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //========================= Altera o Job ===========================//
            //==================================================================//

            jobValores = {
                id: jobValores.id,
                //
                naoTemEnvioAprov: jobValores?.naoTemEnvioAprovacao,
                dateEnvAprov: jobValores?.dataEnvioAprovacaoContratual,
                dateEnvEfetiva: jobValores?.dataEnvioAprovacaoEfetiva,
                //
                naoTemAprov: jobValores?.naoTemAprovacao,
                dateAprovPrevista: jobValores?.dataAprovacaoPrevista,
                dateAprovEfetiva: jobValores?.dataAprovacaoEfetiva,
                //
                naoTemInspec: jobValores?.naoTemInspecao,
                dateInspecPrev: jobValores?.dataInspecaoPrevista,
                dateInspecEfetiva: jobValores?.dataInspecaoEfetiva,
                //
                naoTemEntregaFis: jobValores?.naoTemEntregaFiscal,
                dateEntregaFisPrev: jobValores?.dataEntregaFiscalPrevista,
                dateEntregaFisEfetiva: jobValores?.dataEntregaFiscalEfetiva,
                //
                naoTemMontagem: jobValores?.naoTemMontagem,
                dateContratualMontagem: jobValores?.dataMontagemContratual,
                dateEfetivaMontagem: jobValores?.dataMontagemEfetiva,
                //
                naoTemStartup: jobValores?.naoTemStartup,
                dateStatupPrev: jobValores?.dataStartupPrevista,
                dateStatupEfetiva: jobValores?.dataStartupEfetiva,
                //
                dateFinalContratual: jobValores?.dataFinalContratual,
                dateFinalEfetiva: jobValores?.dataFinalEfetiva,
            }

            job = await this.alterarJob(jobValores);
            if(job.status != 200){
                throw job;
            }

            console.log(job);

        }catch(e){

            console.log(e);
            return job;

        }

        return job;

    },

    async finalizarPreenchimentoDeCoordenador(jobValores = {}){

        let job;

        try{

            //==================================================================//
            //========================= Altera o Job ===========================//
            //==================================================================//

            jobValores = {
                id: jobValores.id,
                status: "Em Execução"
            }

            job = await this.alterarJob(jobValores);
            if(job.status != 200){
                throw job;
            }

        }catch(e){

            console.log(e);
            return job;

        }

        return job;

    },

    async iniciarRevisao(jobValores = {}){

        let job;

        try{

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //====================== Pega Subitens do Item =====================//
            //==================================================================//
            const pegaSubitens = async (subItens = []) =>{

                //==================================================================//
                //======== Retorna Array Vazio se Não Existem Subitens =============//
                //==================================================================//
                if(subItens.length == 0){
                    return [];
                }

                //==================================================================//
                //================ Pega os Subitens do Item ========================//
                //==================================================================//
                subItens = await JobSubitensService.pegaSubitens(subItens);
                if(subItens.status != 200){
                    throw subItens;
                }

                //==================================================================//
                //================= Trata os Subitens do Item ======================//
                //==================================================================//
                subItens = subItens?.data?.map((subItem)=>{

                    return{
                        id: subItem?.id,
                        codigo: subItem?.codigo,
                        status: subItem?.status,
                        sequencia: subItem?.sequencia,
                        //
                        descricao: subItem?.descricao,
                        //
                        quantidade: subItem?.quantidade,
                        valorTotal: subItem?.valorTotal,
                        valorUnitario: subItem?.valorUnitario,
                    }

                });

                return subItens;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //======================== Pega Itens do Job =======================//
            //==================================================================//
            const pegaItens = async (itens = []) =>{

                //==================================================================//
                //========= Retorna Array Vazio se Não Existem Itens ===============//
                //==================================================================//
                if(itens.length == 0){
                    return [];
                }

                //==================================================================//
                //==================== Pega os Itens do Job ========================//
                //==================================================================//
                itens = await JobItensService.pegaItens(itens);
                if(itens.status != 200){
                    throw itens;
                }

                //==================================================================//
                //==================== Trata os Itens do Job =======================//
                //==================================================================//
                itens = await UtilSequence.each({
                    list: itens?.data,
                    callback: async (item)=>{

                        return{
                            id: item?.id,
                            codigo: item?.codigo,
                            status: item?.status,
                            sequencia: item?.sequencia,
                            descricao: item?.descricao,
                            //
                            dataPrazoEntrega: UtilDateTime.toFormatUTC({dateTime:item?.dataPrazoEntrega}),
                            //
                            quantidade: item?.quantidade,
                            precoUnitario: item?.precoUnitario,
                            precoTotal: item?.precoTotal,
                            //
                            valorBaseICMS_ISS: item?.valorBaseICMS_ISS,
                            porcentagemICMS: item?.porcentagemICMS,
                            valorICMS: item?.valorICMS,
                            porcentagemIPI: item?.porcentagemIPI,
                            valorIPI: item?.valorIPI,
                            porcentagemISS: item?.porcentagemISS,
                            valorISS: item?.valorISS,
                            //
                            tipoDeEquipamento: item?.tipoDeEquipamento,
                            //
                            itens: await pegaSubitens(item?.itens),
                        }

                    }
                });

                return itens;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //========================== Pega o Job ============================//
            //==================================================================//

            jobValores = {
                id: jobValores?.id
            }

            job = await this.getJob(jobValores.id);
            if(job.status != 200){
                throw job;
            }

            jobValores = {
                id: job?.data.id,
                codigo: job?.data?.code,
                status: job?.data?.status,
                //
                valorAtual: job?.data?.valorJob,
                //
                dataAbertura: UtilDateTime.toFormatUTC({dateTime:job?.data?.dataAbertura}),
                dataEntregaContratual: UtilDateTime.toFormatUTC({dateTime:job?.data?.dataEntregaContratual}),
                tipoDeEquipamento: job?.data?.tipo,
                ncm: job?.data?.ncm,
                clienteEmailXML: job?.data?.email,
                clientePedidoDeCompra: job?.data?.pedidoCompra,
                descricao: job?.data?.description,
                condicaoDePagamento: job?.data?.condicaoDePagamento,
                observacao: job?.data?.observacao,
                transporte: job?.data?.transporte,
                //
                naoTemEnvioAprovacao: job?.data?.naoTemEnvioAprov,
                dataEnvioAprovacaoContratual: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateEnvAprov}),
                dataEnvioAprovacaoEfetiva: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateEnvEfetiva}),
                //
                naoTemAprovacao: job?.data?.naoTemAprov,
                dataAprovacaoPrevista: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateAprovPrevista}),
                dataAprovacaoEfetiva: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateAprovEfetiva}),
                //
                naoTemInspecao: job?.data?.naoTemInspec,
                dataInspecaoPrevista: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateInspecPrev}),
                dataInspecaoEfetiva: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateInspecEfetiva}),
                //
                naoTemEntregaFiscal: job?.data?.naoTemEntregaFis,
                dataEntregaFiscalPrevista: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateEntregaFisPrev}),
                dataEntregaFiscalEfetiva: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateEntregaFisEfetiva}),
                //
                naoTemMontagem: job?.data?.naoTemMontagem,
                dataMontagemContratual: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateContratualMontagem}),
                dataMontagemEfetiva: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateEfetivaMontagem}),
                //
                naoTemStartup: job?.data?.naoTemStartup,
                dataStartupPrevista: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateStatupPrev}),
                dataStartupEfetiva: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateStatupEfetiva}),
                //
                dataFinalContratual: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateFinalContratual}),
                dataFinalEfetiva: UtilDateTime.toFormatUTC({dateTime:job?.data?.dateFinalEfetiva}),
                //
                solicitacaoDeOrcamento: job?.data?.solicitacaoDeOrcamento,
                cliente: job?.data?.cliente,
                comercial: job?.data?.comercial,
                gestorDeContratos: job?.data?.gestorDeContratos,
                coordenadorDeContratos: job?.data?.collaboradorId,
                //
                itens: await pegaItens(job?.data?.jobItens)
            }
            
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //========== Cria os Subitens do Item da Revisão do Job ============//
            //==================================================================//

            const criaSubitens = async (subItens = []) =>{

                //==================================================================//
                //======== Retorna Array Vazio se Não Existem Subitens =============//
                //==================================================================//
                if(subItens.length == 0){
                    return [];
                }

                //==================================================================//
                //========= Prepara os Subitens do Item da Revisão do Job ==========//
                //==================================================================//
                subItens = subItens?.map((subItem)=>{

                    return{
                        jobItemSubItem: subItem?.id,
                        status: subItem?.status,
                        sequencia: subItem?.sequencia,
                        //
                        descricao: subItem?.descricao,
                        //
                        quantidade: subItem?.quantidade,
                        valorTotal: subItem?.valorTotal,
                        valorUnitario: subItem?.valorUnitario,
                    }

                });

                //==================================================================//
                //========= Cria os Subitens do Item da Revisão de Job =============//
                //==================================================================//
                subItens = await RevisaoDeJobSubItensService.criaSubitens(subItens);
                if(subItens.status != 200){
                    throw subItens;
                }

                //==================================================================//
                //===== Retorna os IDS dos Subitens do Item da Revisão de Job ======//
                //==================================================================//
                let subItensIDs = subItens?.data?.map(({id})=>id);

                return subItensIDs;

            }
            
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //=============== Cria os Itens da Revisão do Job ==================//
            //==================================================================//

            const criaItens = async (itens = []) =>{

                //==================================================================//
                //========= Retorna Array Vazio se Não Existem Itens ===============//
                //==================================================================//
                if(itens.length == 0){
                    return [];
                }

                //==================================================================//
                //============ Prepara os Itens da Revisão do Job ==================//
                //========= Tambem cria os Subitens dos Itens do Job ===============//
                //==================================================================//
                itens = await UtilSequence.each({
                    list: itens,
                    callback: async (item)=>{

                        return{
                            jobItem: item?.id,
                            status: item?.status,
                            sequencia: item?.sequencia,
                            descricao: item?.descricao,
                            //
                            dataPrazoEntrega: UtilDateTime.toFormatUTC({dateTime:item?.dataPrazoEntrega}),
                            //
                            quantidade: item?.quantidade,
                            precoUnitario: item?.precoUnitario,
                            precoTotal: item?.precoTotal,
                            //
                            valorBaseICMS_ISS: item?.valorBaseICMS_ISS,
                            porcentagemICMS: item?.porcentagemICMS,
                            valorICMS: item?.valorICMS,
                            porcentagemIPI: item?.porcentagemIPI,
                            valorIPI: item?.valorIPI,
                            porcentagemISS: item?.porcentagemISS,
                            valorISS: item?.valorISS,
                            //
                            tipoDeEquipamento: item?.tipoDeEquipamento,
                            //
                            itens: await criaSubitens(item?.itens),
                        }

                    }
                });

                //==================================================================//
                //================ Cria os Itens da Revisão do Job =================//
                //==================================================================//

                itens = await RevisaoDeJobItensService.criaItens(itens);
                if(itens.status != 200){
                    throw itens;
                }

                //==================================================================//
                //=========== Retorna os IDS dos Itensda Revisão de Job ============//
                //==================================================================//
                let itensIDs = itens?.data?.map(({id})=>id);

                return itensIDs;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //==================== Cria a Revisão do Job =======================//
            //==================================================================//

            let revisaoValores = {
                job: jobValores?.id,
                status: jobValores?.status,
                //
                valorJob: jobValores?.valorAtual,
                //
                dataAbertura: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataAbertura}),
                dataEntregaContratual: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEntregaContratual}),
                tipo: jobValores?.tipoDeEquipamento,
                ncm: jobValores?.ncm,
                email: jobValores?.clienteEmailXML,
                pedidoCompra: jobValores?.clientePedidoDeCompra,
                description: jobValores?.descricao,
                condicaoDePagamento: jobValores?.condicaoDePagamento,
                observacao: jobValores?.observacao,
                transporte: jobValores?.transporte,
                //
                naoTemEnvioAprov: jobValores?.naoTemEnvioAprovacao,
                dateEnvAprov: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEnvioAprovacaoContratual}),
                dateEnvEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEnvioAprovacaoEfetiva}),
                //
                naoTemAprov: jobValores?.naoTemAprovacao,
                dateAprovPrevista: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataAprovacaoPrevista}),
                dateAprovEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataAprovacaoEfetiva}),
                //
                naoTemInspec: jobValores?.naoTemInspecao,
                dateInspecPrev: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataInspecaoPrevista}),
                dateInspecEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataInspecaoEfetiva}),
                //
                naoTemEntregaFis: jobValores?.naoTemEntregaFiscal,
                dateEntregaFisPrev: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEntregaFiscalPrevista}),
                dateEntregaFisEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEntregaFiscalEfetiva}),
                //
                naoTemMontagem: jobValores?.naoTemMontagem,
                dateContratualMontagem: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataMontagemContratual}),
                dateEfetivaMontagem: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataMontagemEfetiva}),
                //
                naoTemStartup: jobValores?.naoTemStartup,
                dateStatupPrev: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataStartupPrevista}),
                dateStatupEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataStartupEfetiva}),
                //
                dateFinalContratual: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataFinalContratual}),
                dateFinalEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataFinalEfetiva}),
                //
                solicitacaoDeOrcamento: jobValores?.solicitacaoDeOrcamento,
                cliente: jobValores?.cliente,
                comercial: jobValores?.comercial,
                gestorDeContratos: jobValores?.gestorDeContratos,
                collaboradorId: jobValores?.coordenadorDeContratos,
                //
                jobItens: await criaItens(jobValores?.itens),
            }

            let revisao = await RevisaoDeJobService.criaRevisao(revisaoValores);
            if(revisao.status != 200){
                throw revisao;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //================== Pega o Novo Código do Job =====================//
            //==================================================================//

            const pegaJobNovoCodigo = (codigoCompleto = "") =>{

                // Divide o Codigo Completo
                let codigoPartes = codigoCompleto.split("-");

                // Parte do Job
                let jobAno = codigoPartes[0] || "";
                let jobNumero = codigoPartes[1] || "";
                let jobCodigo = `${jobAno}-${jobNumero}`;

                // Parte da Revisão
                let revisaoCodigo = codigoPartes[2] || "";
                let revisaoSigla = "REV";
                let revisaoNumero = revisaoCodigo.slice(-2);
                let revisaoNumeroConvertido = Number(revisaoNumero) || 0;
                let revisaoNovoNumero = `${revisaoNumeroConvertido + 1}`;
                let revisaoNovoNumeroFormatado = revisaoNovoNumero?.padStart(2,"0");

                // Monta o Novo Codigo Completo.
                let codigoCompletoNovo = `${jobCodigo}-${revisaoSigla}${revisaoNovoNumeroFormatado}`;

                // Retorna o Codigo.
                return codigoCompletoNovo;

            };

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //===================== Altera o Job Que foi Revisado ==============//
            //==================================================================//

            jobValores = {
                id: jobValores.id,
                code: pegaJobNovoCodigo(jobValores.codigo),
                status: "Em Revisão",
            }

            job = await this.alterarJob(jobValores);
            if(job.status != 200){
                throw job;
            }

        }catch(e){

            console.log(e);
            return job;

        }

        return job;

    },

    async salvarRevisao(jobValores = {}){

        let job;

        try{

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //====================== Gerencia Itens do Job =====================//
            //==================================================================//
            const gerenciaItens = async (job) =>{

                let itens = await UtilSequence.each({
                    list: job?.itens,
                    callback: async (item)=>{

                        //==================================================================//
                        //===================== Remove Itens do Job ========================//
                        //==================================================================//

                        if(item.remover == true){
                            item = await removeItem(item);
                            return;
                        }

                        //==================================================================//
                        //======================= Cria Itens do Job ========================//
                        //==================================================================//

                        if(item.rascunho == true){
                            item = await criaItem(item);
                            return item;
                        }

                        //==================================================================//
                        //====================== Altera Itens do Job =======================//
                        //==================================================================//

                        item = await alteraItem(item);
                        return item;

                    },
                });

                return itens;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //===================== Remove Item do Job =========================//
            //==================================================================//

            const removeItem = async (item) => {

                await gerenciaSubItens(item);
                
                let itemValores = {
                    id: item?.id
                }

                item = await JobItensService.removeItem(itemValores);
                if(item.status != 200){
                    throw item;
                }

                return item;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //======================= Cria Item do Job =========================//
            //==================================================================//

            const criaItem = async (item) => {

                let subItens = await gerenciaSubItens(item);
                let subItensIDs = subItens?.map(({id})=>id);
                
                let itemValores = {
                    sequencia: item?.sequencia,
                    tipoDeEquipamento: item?.tipoDeEquipamento,
                    descricao: item?.descricao,
                    dataPrazoEntrega: UtilDateTime.toFormatUTC({dateTime:item?.dataPrazoEntrega}),
                    quantidade: item?.quantidade,
                    precoUnitario: item?.precoUnitario,
                    precoTotal: item?.precoTotal,
                    valorBaseICMS_ISS: item?.valorBaseICMS_ISS,
                    porcentagemICMS: item?.porcentagemICMS,
                    valorICMS: item?.valorICMS,
                    porcentagemIPI: item?.porcentagemIPI,
                    valorIPI: item?.valorIPI,
                    porcentagemISS: item?.porcentagemISS,
                    valorISS: item?.valorISS,
                    itens: subItensIDs,
                }

                item = await JobItensService.criaItem(itemValores);
                if(item.status != 200){
                    throw item;
                }

                return item.data;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //====================== Altera Item do Job ========================//
            //==================================================================//

            const alteraItem = async (item) => {

                let subItens = await gerenciaSubItens(item);
                let subItensIDs = subItens?.map(({id})=>id);
                
                let itemValores = {
                    id: item?.id,
                    sequencia: item?.sequencia,
                    tipoDeEquipamento: item?.tipoDeEquipamento,
                    descricao: item?.descricao,
                    dataPrazoEntrega: UtilDateTime.toFormatUTC({dateTime:item?.dataPrazoEntrega}),
                    quantidade: item?.quantidade,
                    precoUnitario: item?.precoUnitario,
                    precoTotal: item?.precoTotal,
                    valorBaseICMS_ISS: item?.valorBaseICMS_ISS,
                    porcentagemICMS: item?.porcentagemICMS,
                    valorICMS: item?.valorICMS,
                    porcentagemIPI: item?.porcentagemIPI,
                    valorIPI: item?.valorIPI,
                    porcentagemISS: item?.porcentagemISS,
                    valorISS: item?.valorISS,
                    itens: subItensIDs,
                }

                item = await JobItensService.alteraItem(itemValores);
                if(item.status != 200){
                    throw item;
                }

                return item.data;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //==================== Gerencia Subitens do Item ===================//
            //==================================================================//

            const gerenciaSubItens = async (item) => {

                let subItens = await UtilSequence.each({
                    list: item?.itens,
                    callback: async (subItem)=>{

                        //==================================================================//
                        //=================== Remove Subitens do Item ======================//
                        //==================================================================//

                        if(item.remover == true || subItem.remover == true){
                            subItem = await removeSubitem(subItem);
                            return;
                        }

                        //==================================================================//
                        //====================== Cria Subitens do Item =====================//
                        //==================================================================//

                        if(subItem.rascunho == true){
                            subItem = await criaSubitem(subItem);
                            return subItem;
                        }

                        //==================================================================//
                        //=================== Altera Subitens do Item ======================//
                        //==================================================================//

                        subItem = await alteraSubitem(subItem);
                        return subItem;

                    },
                });

                return subItens;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //=================== Remove Subitem do Item =======================//
            //==================================================================//

            const removeSubitem = async (subItem) => {

                let subItemValores = {
                    id: subItem?.id
                }

                subItem = await JobSubitensService.removeSubItem(subItemValores);
                if(subItem.status != 200){
                    throw subItem;
                }

                return subItem;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //======================= Cria Item do Job =========================//
            //==================================================================//

            const criaSubitem = async (subItem) => {
                
                let subItemValores = {
                    descricao: subItem?.descricao,
                    quantidade: subItem?.quantidade,
                    sequencia: subItem?.sequencia,
                    valorTotal: subItem?.valorTotal,
                    valorUnitario: subItem?.valorUnitario,
                }

                subItem = await JobSubitensService.criaSubitem(subItemValores);
                if(subItem.status != 200){
                    throw subItem;
                }

                return subItem.data;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //===================== Altera Subitem do Job ======================//
            //==================================================================//

            const alteraSubitem = async (subItem) => {

                let subItemValores = {
                    id: subItem?.id,
                    descricao: subItem?.descricao,
                    quantidade: subItem?.quantidade,
                    sequencia: subItem?.sequencia,
                    valorTotal: subItem?.valorTotal,
                    valorUnitario: subItem?.valorUnitario,
                }

                subItem = await JobSubitensService.alteraSubitem(subItemValores);
                if(subItem.status != 200){
                    throw subItem;
                }

                return subItem.data;

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //======================= Altera Job Itens =========================//
            //==================================================================//

            jobValores.itens = await gerenciaItens(jobValores);
            console.log(jobValores);
            jobValores.itens = jobValores?.itens?.map(({id}) => id) || [];

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //========================= Altera o Job ===========================//
            //==================================================================//

            jobValores = {
                id: jobValores.id,
                //
                dataEntregaContratual: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEntregaContratual}),
                ncm: jobValores?.ncm,
                email: jobValores?.clienteEmailXML,
                pedidoCompra: jobValores?.clientePedidoDeCompra,
                description: jobValores?.descricao,
                condicaoDePagamento: jobValores?.condicaoDePagamento,
                observacao: jobValores?.observacao,
                transporte: jobValores.transporte,
                //
                naoTemEnvioAprov: jobValores?.naoTemEnvioAprovacao,
                dateEnvAprov: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEnvioAprovacaoContratual}),
                dateEnvEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEnvioAprovacaoEfetiva}),
                //
                naoTemAprov: jobValores?.naoTemAprovacao,
                dateAprovPrevista: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataAprovacaoPrevista}),
                dateAprovEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataAprovacaoEfetiva}),
                //
                naoTemInspec: jobValores?.naoTemInspecao,
                dateInspecPrev: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataInspecaoPrevista}),
                dateInspecEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataInspecaoEfetiva}),
                //
                naoTemEntregaFis: jobValores?.naoTemEntregaFiscal,
                dateEntregaFisPrev: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEntregaFiscalPrevista}),
                dateEntregaFisEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataEntregaFiscalEfetiva}),
                //
                naoTemMontagem: jobValores?.naoTemMontagem,
                dateContratualMontagem: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataMontagemContratual}),
                dateEfetivaMontagem: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataMontagemEfetiva}),
                //
                naoTemStartup: jobValores?.naoTemStartup,
                dateStatupPrev: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataStartupPrevista}),
                dateStatupEfetiva:UtilDateTime.toFormatUTC({dateTime:jobValores?.dataStartupEfetiva}),
                //
                dateFinalContratual: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataFinalContratual}),
                dateFinalEfetiva: UtilDateTime.toFormatUTC({dateTime:jobValores?.dataFinalEfetiva}),
                //
                jobItens: jobValores?.itens,
            }

            job = await this.alterarJob(jobValores);
            if(job.status != 200){
                throw job;
            }

            console.log(job);

        }catch(e){

            console.log(e);
            return job;

        }

        return job;

    },

    async finalizarRevisao(jobValores = {}){

        let job;

        try{

            //==================================================================//
            //========================= Altera o Job ===========================//
            //==================================================================//

            jobValores = {
                id: jobValores.id,
                status: "Em Execução"
            }

            job = await this.alterarJob(jobValores);
            if(job.status != 200){
                throw job;
            }

        }catch(e){

            console.log(e);
            return job;

        }

        return job;

    },

     async cancelarJob(jobValores = {}){

        let job;

        try{

            //==================================================================//
            //========================= Altera o Job ===========================//
            //==================================================================//

            let JobID = jobValores.id;

            jobValores = {
                id: JobID,
                justificativaDeCancelamento: jobValores.justificativaDeCancelamento || "",
                status: "Cancelado"
            }

            job = await this.alterarJob(jobValores);
            if(job.status != 200){
                throw job;
            }

            //==================================================================//
            //========================== Pega o Job ============================//
            //==================================================================//

            job = await this.getJob(JobID);
            if(job.status != 200){
                throw job;
            }

            //==================================================================//
            //============ Remove o Job da Solicitação de Orçamento ============//
            //==================================================================//

            let solicitacaoDeOrcamentoID = job.data.solicitacaoDeOrcamento;

            let solicitacaoDeOrcamento = await SolicitacaoDeOrcamentoService.removeJob(solicitacaoDeOrcamentoID);
            if(solicitacaoDeOrcamento.status != 200){
                throw job;
            }

        }catch(e){

            console.log(e);
            return job;

        }

        return job;

    },

}